import { joinParts } from './utils'

export const home = {
  components: () => joinParts('home'),
}
